module.exports = __webpack_public_path__ + "img/blue_071.db2574ae.png";